import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import { nSQL } from "@nano-sql/core";
import * as utils from "@nano-sql/core/lib/utilities";

utils.uuid();

if (!Object.prototype.forEach) {
  Object.defineProperty(Object.prototype, 'forEach', {
    value: function (callback, thisArg) {
      if (this == null) {
        throw new TypeError('Not an object');
      }
      thisArg = thisArg || window;
      for (var key in this) {
        if (this.hasOwnProperty(key)) {
          callback.call(thisArg, this[key], key, this);
        }
      }
    }
  });
}

export default new Vuex.Store({

  // system vars;
  state: {
    loaded: false,
    settings: {
      theme: 'default',
    },
    assetToUpload: null,
    imageToUpload: null,
    config: [],
    assets: [],
    labels: [],
    contents: [],
    view_summary: false,
    finishUpload: true,
    language: "",
    translate: () => {},
    params: () => {},
    allAssets: [], 
    currentAssetSelected: null,
    status: '',
    status_visible: false,
    apiConfig: {},
    viewExtraFunction: '',
    // insert app related here;
    /////////////////////////////
  },

  mutations: {
    preload_mutation(state, val) {
      setTimeout(()=>{
        state.loaded = val;
      }, 100);
    },
    view_extra_function_mutation(state, val) {
      state.viewExtraFunction = val;
    },
    settings_mutation(state, val) {
      state.settings[val.key] = val.value;
    },
    status_mutation(state, val){
      setTimeout(() => {
        state.status = val;
        if(!state.status_visible){
          state.status_visible = true;
          setTimeout(()=>{
            state.status = '';
            state.status_visible = false;
          }, 3000);
        }
      }, 1000)
    },
    assets_mutation(state, val) {
      state.config = val;
      state.assets = val.assets;
      state.labels = val.labels;
      state.contents = val.contents;
      state.translate = (t) => {
        let translated = JSON.parse(JSON.stringify(state.labels["en"]));
        let phrase = JSON.parse(JSON.stringify(translated[t] ? translated[t] : null));
        if (phrase != null && phrase != undefined) {
          return phrase.value;
        }
      }
      state.params = (p) => {
        let param = JSON.parse(JSON.stringify(state.labels["params"]));
        let v = JSON.parse(JSON.stringify(param[p]));
        if (v != null && v != undefined) {
          return v.value;
        }
      }
      // Loop basic structure ////////////////////////////////////////////////////
      let content = val.contents;
      let lbl = val.labels[state.language];
      let asst = val.assets;
      let tableIds = [];
      let tableAssets = [];
      let tableLabels = [];

      // mount labels;
      for (var key_l in lbl) {
        if (lbl.hasOwnProperty(key_l)) {
          tableLabels.push({
            id: key_l,
            label: lbl[key_l].value
          });
        }
      }
      // mount content;
      for (var key_c in content) {
        if (content.hasOwnProperty(key_c)) {
          tableIds.push({
            id: key_c,
            code: content[key_c].value[0]
          });
        }
      }
      // mount assets;
      for (var key_a in asst) {
        if (asst.hasOwnProperty(key_a)) {
          tableIds.map(table => {
            if (table.code == key_a) {
              tableAssets.push({
                id: table.id,
                code: key_a,
                slug: asst[key_a].slug,
                type: asst[key_a].type,
                name: asst[key_a].displayName,
                description: asst[key_a].description,
                url: asst[key_a].applink,
                preview: window.ShowpadLib.getAssetPreviewUrl(key_a, asst[key_a].slug, 512)
              });
            }
          });
        }
      }
      //////////////////////////////////////////////////////////////////////////////
      state.allAssets = tableAssets;
      this.dispatch('create_db_action');
    },
    get_single_asset_mutation(state, val) {
      state.allAssets.map((asset) => {
        if (asset.id === val){
          state.currentAssetSelected = asset;
        }
      })
    },
    apiConfig_mutation(state, val) {
      state.apiConfig = val;
      console.log("API CONFIG: ", val);
    },
    view_summary_mutation(state, val) {
      state.view_summary = val;
    },
    image_to_upload_mutation(state, val) {
      state.imageToUpload = val;
    },
    // insert app related here;
    /////////////////////////////
  },

  getters: {
    preload_data: state => state.loaded,
    params_data: state => state.params,
    assets_data: state => state.assets,
    labels_data: state => state.labels,
    contents_data: state => state.contents,
    config_data: state => state.config,
    loaded_data: state => state.loaded,
    translate_data: state => state.translate,
    selected_asset_data: state => state.currentAssetSelected,
    allAssets_data: state => state.allAssets,    
    status_data: state => state.status, 
    view_summary: state => state.view_summary,
    finishUpload: state => state.finishUpload,
    view_extra_function_data: state => state.viewExtraFunction,
  },

  // return values (async);
  actions: {
    
    // main scope //
    async start_action(context) {

      // reads config URL /////////////////////////////////////////////////////////
      function readQueryParams(params) {
        return params.substr(1).split("&").reduce(function (acc, pair) {
          if (!pair)
            return acc;
          var parts = pair.split("=");
          acc[parts[0]] = parts[1];
          return acc;
        }, {});
      }
      let queryParams = readQueryParams(window.location.search);
      let currentConfig = decodeURIComponent(queryParams['configUrl']);
      let localConfig = "config.json";
      let configUrl = currentConfig != "undefined" ? currentConfig : localConfig;
      /////////////////////////////////////////////////////////////////////////////

      // main function ////////////////////////////////////////////////////////////
      const initApp = ()=>{
        window.$.getJSON(configUrl, config => {
          context.commit("assets_mutation", config);
          let languagesList = [];
          config.labels.forEach((item, key) => {
            if(key != "params"){
              languagesList.push({ id: key, val: item.description});
            } 
          })
        });
      };

      if (window.location.protocol === "http:" && window.location.port === "8080") {
        window.ShowpadLib = {
          getAssetPreviewUrl: function () { return "./images/placeholders/placeholder.svg" }
        }
        initApp();
      }else{
        window.onShowpadLibLoaded = function () {
          let onShowpadApiConfig = (config) => {
            context.commit("apiConfig_mutation", config);
          }
          window.ShowpadLib.getShowpadApi(onShowpadApiConfig);
          initApp();
         };
      }
      /////////////////////////////////////////////////////////////////////////////

    },
    async create_db_action(context) {
      
      // ! temporary solution //////////////////////////////
      if (!window.localStorage.main_db__ttl_idb_version){
      /// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

        // basic database setup;
        nSQL().createDatabase({
          id: "main_db",
          mode: "PERM",
          history: true,
          historyMode: "row"
        }).then(()=>{
  
          // set as main database;
          nSQL().useDatabase("main_db");
  
          // Create Params Table
          nSQL().query('create table', {
            name: "main_params",
            model: {
              "id:uuid": {},
              "name:string": { pk: true, notNull: true },
              "value:string": { default: false },
            }
          }).exec().then(()=>{
  
            // Insert main params from config into database;
            nSQL().rawImport({
              main_params: [
                {
                  name: 'theme',
                  value: context.state.params('theme'),
                },
                {
                  name: 'default_language',
                  value: context.state.params('default_language'),
                }
              ]
            });
  
            // Set preloader to true
            //this.commit("preload_mutation", true);
            this.commit("status_mutation", 'Checking for updates');
  
          });
          
        });

      }else{
        //this.commit("preload_mutation", true);
        this.commit("status_mutation", "Checking for updates");
      }
      
    },
    async uploadAsset(context) {

      let file = context.state.assetToUpload;
      console.log("ASSET TO UPLOAD: ", context.state.assetToUpload)
      context.state.finishUpload = false;

      let getPreview = (id) => {
        const url = context.state.apiConfig.url + '/api/v3/assets/' + id + '.json';
        const config = {
          headers: {
            'Authorization': "Bearer " + context.state.apiConfig.accessToken + ""
          }
        };
        fetch(url, config)
          .then(response => response.json())
          .then(json => {
            if (json.response) {
              let slug = json.response.appLink.replace("showpad://file/", "")
              let assetSlugs = [slug];
              ///////////////////////////////////////////////
              let type = 'link'; // Can be 'email' or 'link'.
              ///////////////////////////////////////////////
              let callback = (r) => {
                console.log(r);
              }
              if (window.ShowpadLib.share(type, assetSlugs, callback)) {
                console.log('called share asset');
              }
              console.log('Asset Data: ', json);
            }
          });
      }
      let pollTicket = (id) => {
        const url = context.state.apiConfig.url + '/api/v3/tickets/' + id + '.json';
        const config = {
          headers: {
            'Authorization': "Bearer " + context.state.apiConfig.accessToken + ""
          }
        };
        fetch(url, config)
          .then(response => response.json())
          .then(json => {
            if (json.response.status) {
              switch (json.response.status) {
                case 'completed':
                  if (json.response.asset && json.response.asset.id) {
                    const assetId = json.response.asset.id;
                    this.pdfStatus = null;
                    console.log("file processed with asset id: " + assetId);
                    getPreview(assetId);
                  }
                  context.state.finishUpload = true;
                  break;
                case 'queued':
                case 'processing':
                  setTimeout(() => {
                    pollTicket(id);
                  }, 2000);
                  break;
                case 'failed':
                  context.state.finishUpload = true;
                  break;
              }
            }
          });
      }
      let url = context.state.apiConfig.url + '/api/v3/divisions/mine/assets.json';
      let FormData = window.FormData;
      let formData = new FormData();
      formData.append('file', file, 'Bridge_Meeting_audio_' + Math.floor(Math.random() * Math.floor(9999)) + '.wav');
      formData.append('isPersonal', 'true');
      formData.append('isSensitive', 'false');
      formData.append('isAnnotatable', 'true');
      formData.append('isDownloadable', 'true');
      formData.append('isEditable', 'true');
      formData.append('isShareable', 'true');
      formData.append('useOptimized', 'true');
      let xhr = new XMLHttpRequest();
      xhr.open('POST', url);
      xhr.setRequestHeader('Authorization', "Bearer " + context.state.apiConfig.accessToken + "");
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          const json = JSON.parse(xhr.responseText);
          if (json.response && json.response.resourcetype === 'Ticket') {
            pollTicket(json.response.id);
          }
        }
      };
      xhr.send(formData);
    },
    async uploadImage(context) {

      let file = context.state.imageToUpload;

      let getPreview = (id) => {
        const url = context.state.apiConfig.url + '/api/v3/assets/' + id + '.json';
        const config = {
          headers: {
            'Authorization': "Bearer " + context.state.apiConfig.accessToken + ""
          }
        };
        fetch(url, config)
          .then(response => response.json())
          .then(json => {
            if (json.response) {
              console.log("ASSET: ", json.response)
              let slug = json.response.appLink.replace("showpad://file/", "")
              let assetSlugs = [slug];
              ///////////////////////////////////////////////
              let type = 'link'; // Can be 'email' or 'link'.
              ///////////////////////////////////////////////
              let callback = (r) => {
                console.log(r);
              }
              if (window.ShowpadLib.share(type, assetSlugs, callback)) {
                console.log('called share asset');
              }
              console.log('Asset Data: ', json);
            }
          });
      }
      let pollTicket = (id) => {
        const url = context.state.apiConfig.url + '/api/v3/tickets/' + id + '.json';
        const config = {
          headers: {
            'Authorization': "Bearer " + context.state.apiConfig.accessToken + ""
          }
        };
        fetch(url, config)
          .then(response => response.json())
          .then(json => {
            if (json.response.status) {
              switch (json.response.status) {
                case 'completed':
                  if (json.response.asset && json.response.asset.id) {
                    const assetId = json.response.asset.id;
                    this.pdfStatus = null;
                    console.log("file processed with asset id: " + assetId);
                    getPreview(assetId);
                  }
                  context.state.finishUpload = true;
                  break;
                case 'queued':
                case 'processing':
                  setTimeout(() => {
                    pollTicket(id);
                  }, 2000);
                  break;
                case 'failed':
                  context.state.finishUpload = true;
                  break;
              }
            }
          });
      }
      let url = context.state.apiConfig.url + '/api/v3/divisions/mine/assets.json';
      let FormData = window.FormData;
      let formData = new FormData();
      formData.append('file', file, 'Bridge_Meeting_selfie_' + Math.floor(Math.random() * Math.floor(9999)) + '.wav');
      formData.append('isPersonal', 'true');
      formData.append('isSensitive', 'false');
      formData.append('isAnnotatable', 'true');
      formData.append('isDownloadable', 'true');
      formData.append('isEditable', 'true');
      formData.append('isShareable', 'true');
      formData.append('useOptimized', 'true');
      let xhr = new XMLHttpRequest();
      xhr.open('POST', url);
      xhr.setRequestHeader('Authorization', "Bearer " + context.state.apiConfig.accessToken + "");
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          const json = JSON.parse(xhr.responseText);
          if (json.response && json.response.resourcetype === 'Ticket') {
            pollTicket(json.response.id);
          }
        }
      };
      xhr.send(formData);
    },
    async exportPDF(context){

      const jsPDF = window.jsPDF;
      const html2canvas = window.html2canvas; 
      var doc;     

      /*const doc = new jsPDF("p", "pt", "letter");
      let source = window.jQuery(".print-template")[0];
      let margins = {
        top: 40,
        bottom: 60,
        left: 40,
        width: 900,
      };

      doc.fromHTML(
        source,
        margins.left,
        margins.top,
        {
          width: margins.width
        },
        // eslint-disable-next-line
        () => {
          pdfDocBlob = doc;
          processPDF();
        },
        margins
      );
      */
      
      var getPreview = (id) => {
        const url = context.state.apiConfig.url + '/api/v3/assets/' + id + '.json';
        const config = {
          headers: {
            'Authorization': "Bearer " + context.state.apiConfig.accessToken + ""
          }
        };
        fetch(url, config)
          .then(response => response.json())
          .then(json => {

            if (json.response) {
              context.state.finishUpload = true;
              let slug = json.response.appLink.replace("showpad://file/", "")
              let assetSlugs = [slug];
              ///////////////////////////////////////////////
              let type = 'link'; // Can be 'email' or 'link'.
              ///////////////////////////////////////////////
              let callback = (r) => {
                console.log(r);
              }
              if (window.ShowpadLib.share(type, assetSlugs, callback)) {
                console.log('called share asset');
              }
              console.log('Asset Data: ', json);
            }
          });
      }

      var pollTicket = (id) => {
        const url = context.state.apiConfig.url + '/api/v3/tickets/' + id + '.json';
        const config = {
          headers: {
            'Authorization': "Bearer " + context.state.apiConfig.accessToken + ""
          }
        };
        fetch(url, config)
          .then(response => response.json())
          .then(json => {
            if (json.response.status) {
              switch (json.response.status) {
                case 'completed':
                  if (json.response.asset && json.response.asset.id) {
                    const assetId = json.response.asset.id;
                    this.pdfStatus = null;
                    console.log("file processed with asset id: " + assetId);
                    getPreview(assetId);
                  }
                  context.state.finishUpload = true;
                  break;
                case 'queued':
                case 'processing':
                  setTimeout(() => {
                    pollTicket(id);
                  }, 2000);
                  break;
                case 'failed':
                  context.state.finishUpload = true;
                  break;
              }
            }
          });
      }

      var processPDF = (pdfDocBlob) => {

        if (window.location.protocol === "http:" && window.location.port === "8080") {
          // Testing on local server ///////////////////////
          pdfDocBlob.save('Roadmap_By_Bridge' + Math.floor(Math.random() * Math.floor(9999)) + '.pdf'); // download
          context.state.finishUpload = true;
          ///////////////////////////////////////////////////
        } else {
          var url = context.state.apiConfig.url + '/api/v3/divisions/mine/assets.json';
          var FormData = window.FormData;
          var formData = new FormData();
          var file = pdfDocBlob.output('blob')
          formData.append('file', file, 'Bridge_PDF_' + Math.floor(Math.random() * Math.floor(9999)) + '.pdf');
          formData.append('isPersonal', 'true');
          //formData.append('isDivisionShared', 'false');
          formData.append('isSensitive', 'false');
          formData.append('isAnnotatable', 'true');
          formData.append('isDownloadable', 'true');
          formData.append('isEditable', 'true');
          formData.append('isShareable', 'true');
          formData.append('useOptimized', 'true');
          var xhr = new XMLHttpRequest();
          xhr.open('POST', url);
          xhr.setRequestHeader('Authorization', "Bearer " + context.state.apiConfig.accessToken + "");
          xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
              const json = JSON.parse(xhr.responseText);
              if (json.response && json.response.resourcetype === 'Ticket') {
                pollTicket(json.response.id);
              }
            }
          };
          xhr.send(formData);
        }

      }

      return html2canvas(window.jQuery(".print-template")[0], {
        onrendered: function (canvas) {
          context.state.finishUpload = false;
          var altIMG = "data:image/png;base64,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";
          var selfie = context.state.imageToUpload ? context.state.imageToUpload  : altIMG;
          var img = canvas.toDataURL("image/png");
          doc = new jsPDF('landscape');
          doc.addImage(img, 'PNG', 28, 10);
          doc.addPage()
          doc.addImage(selfie, 'PNG', 10, 10, 280, 190);
          processPDF(doc)
        }

      });

    },
    
  }

});
